import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MessageService } from 'primeng/api';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-google-auth',
  templateUrl: './google-auth.component.html',
  styleUrls: ['./google-auth.component.scss'],
  providers: [MessageService]
})
export class GoogleAuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private googleData: any = null;
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private productService: ProductService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 800);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      const code = params['code'];
      const state = params['state'];
      const error = params['error'];

      if (state) {
        try {
          const stateObj = JSON.parse(atob(state));
          this.selectedStoreId = stateObj.selectedStoreId || '';
          if (this.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);
          if (stateObj.accessToken) localStorage.setItem('access_token', stateObj.accessToken);
        } catch (e) {
          console.warn('State inválido', e);
        }
      }

      if (!this.selectedStoreId) {
        this.selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      }

      if (error) {
        this.showError('Autorização negada pelo usuário.');
        return;
      }

      if (code && state) this.finishGoogleLogin(code, state);
    });
  }

  private finishGoogleLogin(code: string, state: string) {
    this.productService.googleOauth(code, state).pipe(
      catchError(() => {
        this.showError('Não foi possível autenticar no Google.');
        return EMPTY;
      })
    ).subscribe(data => {
      this.googleData = data;
      this.autoIntegrate();
    });
  }

  private autoIntegrate() {
    if (!this.selectedStoreId || !this.googleData) {
      this.showError('Loja não identificada. Tente novamente.');
      return;
    }

    localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);

    const payload = {
      access_token: this.googleData.access_token,
      refresh_token: this.googleData.refresh_token,
      expires_in: this.googleData.expires_in,
      id_token: this.googleData.id_token,
      scope: this.googleData.scope,
      google_id: this.googleData.google_id,
      token_type: this.googleData.token_type,
      status: 'active',
      form_value: {
        google_id: this.googleData.google_id,
        name: this.googleData.name || this.googleData.email || 'Google User',
        email: this.googleData.email || null,
        picture: this.googleData.picture || null,
      },
    };

    this.productService.createAppsStore2('google', payload).pipe(
      catchError(() => {
        this.showError('Não foi possível salvar integração.');
        return EMPTY;
      })
    ).subscribe(() => {
      this.loading = false;
      // const isAndroid = /android/i.test(navigator.userAgent);
      // if (isAndroid) {
      //   window.location.href = 'myslick://auth/google?result=success';
      //   return;
      // }
      try {
        const channel = new BroadcastChannel('oauth-channel');
        channel.postMessage({ type: 'google-connected' });
        channel.close();
      } catch {}
      try { window.close(); } catch {}
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => { try { window.close(); } catch {} }, 3000);
  }
}
